itsoftApp.createModule("insertUtekaSlider", ["utekaInit"], function () {
    var module = this;
    var insertUtekaSlider = function () {
        var widget = document.querySelector('.uteka-widget')
        var tabs = document.querySelector('.uteka-widget__tabs')
    
        // Подписываемся на выбор другого товара
        tabs.addEventListener('click', function (event) {
            if (event.target.tagName !== 'BUTTON') return
    
            var productId = event.target.dataset.productId
            var tabActive = tabs.querySelector('.uteka-widget__tab._active')
            tabActive.classList.remove('_active');
            tabActive.removeAttribute('disabled');
            
            setTimeout(() => {
                event.target.classList.add('_active');
                event.target.setAttribute('disabled', '');
            }, 100);
    
            // Загружаем выбранный товар в виджет
            window.uteka.loadWidget(widget, {
            productId: productId
            })
        })
    
        // По умолчанию загружаем в виджет первый товар
        var firstTab = tabs.querySelector('.uteka-widget__tab._active');
        firstTab.setAttribute('disabled', '');
    
        window.uteka.loadWidgetPre(widget, {
            productId: firstTab.dataset.productId
        })
    };

    module.callback = insertUtekaSlider
});
